import * as type from '../../../actions/index.types'

const initialState = {
    loading: false,
    memberDaybookData: null,
    error: null,
};

export function MemberDaybookReducer(state = initialState, action) {

    switch (action.type) {
        // Get Member Daybook
        case type.GET_MEMBER_DAYBOOK:
            return {
                ...state,
                loading: true,
                error: null,
            }
        case type.GET_MEMBER_DAYBOOK_SUCCESS:
            return {
                ...state,
                error: null,
                loading: false,
                memberDaybookData: action.payload,
            }
        case type.GET_MEMBER_DAYBOOK_FAILURE:
            return {
                ...state,
                error: action?.message || 'Something went wrong.',
                loading: false,
            }

        // Clear State
        case type.CLEAR_MEMBER_DAYBOOK_STATE:
            return initialState;

        default:
            return state
    }
}
